import { useAuthStore } from "@/store/auth";

const beforeEach = (to, from, next) => {
    const authStore = useAuthStore(); // Get store instance inside the guard

    if (to.meta.requiresAuth && !authStore.authenticated) {
        console.log("unAuthenticated: Redirecting to login");
        next({ path: "/login", query: { redirect: to.fullPath } }); // preserve original destination
    } else if (to.path === "/login" && authStore.authenticated) {
        console.log("Authenticated: Redirecting to home");
        next("/"); // already logged in
    } else {
        // console.log("Navigation: Proceeding");
        next();
    }
};

export default beforeEach;
